export const typeFilesInchat = [
  {
    value: '',
    label: 'dashboard_all'
  },
  {
    value: 'image',
    label: 'dashboard_image'
  },
  {
    value: 'video',
    label: 'dashboard_video'
  },
  {
    value: 'audio',
    label: 'dashboard_audio'
  },
  {
    value: 'document',
    label: 'dashboard_document'
  },
  {
    value: 'application',
    label: 'dashboard_application'
  },
  {
    value: 'text',
    label: 'dashboard_text'
  },
  {
    value: 'other',
    label: 'dashboard_others'
  }
]

export const orderFilesInchat = [
  {
    value: 'asc',
    label: 'asc'
  },
  {
    value: 'desc',
    label: 'desc'
  }
]